export const ApiHeader = {
  ETag: 'ETag',
  IfModifiedSince: 'If-Modified-Since',
  IfNoneMatch: 'If-None-Match',
  LastModified: 'Last-Modified',
  OrganizationId: 'x-organization-id',
} as const;

export const HttpObserve = {
  Response: 'response',
} as const;

export const ApiEndpoint = {
  AdminPanelFinanceCredentialProfiles: 'admin-panel/finance-credential-profiles',
  AdminPanelOrganizationCreationRequests: 'admin-panel/organization-creation-requests',
  AdminPanelOrganizationInvestorInvitations: 'admin-panel/organization-investor-invitations',
  AdminPanelOrganizationInvestorMappings: 'admin-panel/organization-investor-mappings',
  AdminPanelOrganizations: 'admin-panel/organizations',
  Comments: 'comments',
  Currencies: 'finance-proxy/currencies',
  Crsf: 'auth/csrf',
  DataAnalyticsDocs: 'data-analytics/documents',
  Details: 'details',
  ExcelFiles: 'uploader/excel-files',
  FinancialMetrics: 'financial-metrics',
  FinanceAccounts: 'finance-proxy/accounts',
  FinanceAccountBalance: 'finance-proxy/balance',
  FinanceCardProducts: 'finance-proxy/card-products',
  FinanceCards: 'finance-proxy/cards',
  FinanceArtifacts: 'finance-proxy/imports',
  FinanceConfig: 'finance-proxy/config',
  FinanceJiraSyncState: 'finance-proxy/jira/sync-state',
  FinanceJiraTickets: 'finance-proxy/jira/tickets',
  FinanceOperations: 'finance-proxy/operations',
  FinanceAdminUsers: 'finance-proxy/admin/users',
  FinanceAdminExternalUsers: 'finance-proxy/admin/external/users',
  FinanceOperationsTransfer: 'finance-proxy/operations/transfer',
  FinanceOperationsWithdrawals: 'finance-proxy/operations/withdrawals',
  FinanceProviders: 'finance-proxy/providers',
  JiraConfig: 'legal-proxy/config',
  JiraSyncState: 'legal-proxy/jira/sync-state',
  JiraTickets: 'legal-proxy/jira/tickets',
  Kpis: 'kpis',
  Logout: '/auth/logout',
  Memberships: 'memberships',
  Notifications: 'notifications',
  NotificationsUnreadCount: 'notifications/unread-count',
  OAuthLogin: 'auth/oauth/rc/login',
  OperationsJiraSyncState: 'operations-proxy/jira/sync-state',
  OperationsJiraTickets: 'operations-proxy/jira/tickets',
  Organizations: 'auth/organizations',
  UserProfile: 'auth/profile',
} as const;

export const NotificationFeatureGroup = {
  OperationServicesFinance: 'operation_services_finance',
  OperationServicesLegal: 'operation_services_legal',
} as const;

export const NotificationFeatureGroupAction = {
  JiraComment: 'jira_comment',
  JiraStatus: 'jira_status',
} as const;

export const NotificationStatus = {
  Read: 'read',
  Unread: 'unread',
} as const;

export const NotificationType = {
  Alert: 'alert',
  Info: 'info',
} as const;

export const DataAnalyticsDocName = {
  PnlStatement: 'pnl-statement',
  FinanceWallets: 'finance-wallets',
} as const;

export const FinanceAccountType = {
  Card: 'card',
  CryptoWallet: 'crypto-wallet',
  FiatWallet: 'fiat-wallet',
} as const;

export const FinanceProviderType = {
  ExcelImport: 'excel-import',
  IiiWallet: 'iii-wallet',
} as const;

export const FinanceProviderStatus = {
  Disabled: 'disabled',
  Enabled: 'enabled',
} as const;

export const AdminLevelRole = {
  Admin: 'admin',
  Approver: 'approver',
  Creator: 'creator',
  Reader: 'reader',
} as const;

export const OrganizationMembershipRole = {
  FinanceManager: 'finance-manager',
  Investor: 'investor',
  Manager: 'manager',
  Member: 'member',
  Owner: 'owner',
} as const;

export const OrganizationMembershipStatus = {
  Active: 'active',
  Disabled: 'disabled',
} as const;

export const OrganizationStatus = {
  Active: 'active',
  Deleted: 'deleted',
  Suspended: 'suspended',
} as const;

export const OrganizationRequestStatus = {
  Approved: 'approved',
  Pending: 'pending',
  Rejected: 'rejected',
} as const;

export const PortalRoleKey = {
  Employee: 'employee',
  FinanceAdmin: 'finance-admin',
  Investor: 'investor',
  Manager: 'manager',
  Owner: 'owner',
} as const;

export const JiraIssueType = {
  Invest: 'Invest BuSaaS',
  PaymentRequest: 'Payment Request BuSaaS',
} as const;

export const JiraIssueStatus = {
  Canceled: 'Canceled',
  Confirm: 'Confirm',
  Done: 'Done',
  InProgress: 'In progress',
  InReview: 'In review',
  NeedMoreInfo: 'Need more info',
  New: 'New',
  NotStarted: 'Not started',
  OnHold: 'On hold',
  Paid: 'Paid',
  Rejected: 'Rejected',
  Review: 'Review',
} as const;

export const JiraProject = {
  Legal: 'LEG',
  Finance: 'PAYM',
} as const;

export const JiraPriority = {
  Blocker: 'Blocker',
  Executive: 'Executive',
  High: 'High',
  Highest: 'Highest',
  Low: 'Low',
  Lowest: 'Lowest',
  Medium: 'Medium',
  Minor: 'Minor',
  None: 'None',
  Urgent: 'Urgent',
} as const;

export const KpiName = {
  AnnualRevenue: 'annual-revenue',
} as const;

export const FinanceOperationType = {
  BalanceAdjustment: 'Balance Adjustment',
  CardOperation: 'Card Operation',
  Deposit: 'Deposit',
  Exchange: 'Exchange',
  MassPayout: 'MassPayout',
  Refund: 'Refund',
  Transfer: 'Transfer',
  Withdrawal: 'Withdrawal',
} as const;

export const OrganizationHistoryAction = {
  Approved: 'approved',
  FinanceManagerAssigned: 'finance_manager_assigned',
  FinanceWalletsUploaded: 'finance_wallets_uploaded',
  GoalSet: 'goal_set',
  InvestorAssigned: 'investor_assigned',
  ManagerAssigned: 'manager_assigned',
  MemberAssigned: 'member_assigned',
  PlStatementUploaded: 'pl_statement_uploaded',
} as const;
